import React, { Component } from 'react'
import styles from './PersonInfoForm.module.scss'
import {
  LabeledInput, Button, Tag, IconButton, LabeledTextarea,
  LabeledGalleryDropZone, RelatedMediaFormSection
} from 'components'
import { icons } from 'assets'
import { PERSON_STORE, PersonStore, GENERAL_STORE, GeneralStore } from 'store'
import { inject } from 'mobx-react'
import { PersonDTO } from 'models'

interface Props {
  [PERSON_STORE]?: PersonStore;
  [GENERAL_STORE]?: GeneralStore;
  person?: any;
}

interface State {
  isScrollOnTop: boolean;
  name: string;
  // url: string;
  tags: string[];
  info: string;
  relatedMedia: any[];
}

class PersonInfoForm extends Component<Props, State> {
  imagesRef: React.RefObject<{
    handleImages: () => Promise<any>;
    getImages: () => any[];
  }>;

  isSubmitWithEnterKeyAllowed: boolean;

  constructor (props: Props) {
    super(props)
    this.state = {
      isScrollOnTop: true,
      name: '',
      // url: '',
      tags: [],
      info: '',
      relatedMedia: []
    }

    this.imagesRef = React.createRef()
    this.isSubmitWithEnterKeyAllowed = true

    this.handleTagInput = this.handleTagInput.bind(this)
    this.handleOnScroll = this.handleOnScroll.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount () {
    this.feedPerson(this.props.person)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (props) {
    this.feedPerson(props.person)
  }

  feedPerson (person) {
    if (person) {
      this.setState({
        name: person.name || '',
        // url: person.url || '',
        tags: person.tags ? person.tags.split(',') : [],
        info: person.info || '',
        relatedMedia: person.relatedMedia || []
      })
    }
  }

  handleTagInput (tag: string) {
    tag = tag.trim().toLocaleLowerCase()
    const { tags } = this.state

    if (tags.includes(tag)) return

    this.setState({ tags: [...tags, tag] })
  }

  handleOnScroll (e: React.UIEvent<HTMLFormElement>) {
    const { isScrollOnTop: wasScrollOnTop } = this.state
    const isScrollOnTop = e.currentTarget.scrollTop === 0
    if (wasScrollOnTop !== isScrollOnTop) this.setState({ isScrollOnTop })
  }

  handleSubmit () {
    if (!this.isSubmitWithEnterKeyAllowed) return

    // const { showError, setLoadingOn } = this.props[GENERAL_STORE]!;
    const {
      [PERSON_STORE]: {
        createPerson, editPerson
      },
      [GENERAL_STORE]: { showError, setLoadingOn },
      person
    } = this.props

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { isScrollOnTop, ...statePersonDetails } = this.state
    if (!statePersonDetails.name) {
      showError('Please provide the NAME of the person.')
      return
    }

    setLoadingOn()

    this.imagesRef.current.handleImages()
      .then(() => {
        const personDetails = {
          ...statePersonDetails,
          tags: statePersonDetails.tags.join(),
          images: this.imagesRef.current.getImages()
        } as PersonDTO

        person
          ? editPerson({ id: person.id, ...personDetails })
          : createPerson(personDetails)
      })
      .catch(err => showError(err.message))
  }

  render () {
    const {
      name,
      // url,
      info,
      tags,
      isScrollOnTop,
      relatedMedia
    } = this.state
    const {
      person,
      [GENERAL_STORE]: { push }
    } = this.props

    return (
      <div className={styles.container}>

        <h1 className={!isScrollOnTop ? styles.overEffect : ''}>
          {
            person
              ? `${person.name}`
              : 'Add a New Person'
          }
        </h1>

        <form onScroll={this.handleOnScroll}>
          <div className={styles.textFieldsContainer}>
            <div className={styles.nameAndTagsContainer}>
              <LabeledInput
                label='Name'
                placeholder='Type the name of the actor, director, producer...'
                onChange={value => this.setState({ name: value })}
                value={name}
              />
              {/* <LabeledInput
              label='Info Website'
              placeholder='URL'
              type='url'
              onChange={value => this.setState({ url: value })}
              value={url}
            /> */}
              <LabeledInput
                label='Tags'
                placeholder='Type a tag for a project, press enter to set a tag'
                keysToHandle={['Enter']}
                onKeyDown={this.handleTagInput}
                onFocus={() => { this.isSubmitWithEnterKeyAllowed = false }}
                onBlur={() => { this.isSubmitWithEnterKeyAllowed = true }}
              />
              <div className={styles.tagsContainer}>
                {tags.map((tag, index) =>
                  <Tag key={index} tag={tag}>
                    <IconButton
                      icon={icons.closeX}
                      className={styles.tagIcon}
                      onClick={() => this.setState({ tags: tags.filter(t => t !== tag) })}
                    />
                  </Tag>
                )}
              </div>
            </div>

            <div className={styles.infoContainer}>
              <LabeledTextarea
                label='Info'
                placeholder={'Provide information here'}
                onChange={value => this.setState({ info: value })}
                value={info}
              />
            </div>
          </div>

          <LabeledGalleryDropZone
            ref={this.imagesRef}
            initialImages={person ? person.images : []}
          />

          <RelatedMediaFormSection
            selectedProjectsList={relatedMedia}
            // projectsList={projectsList}
            // getProjects={getProjects}
            setSelectedProjectsList={projects =>
              this.setState({ relatedMedia: projects })
            }
          />

          <div className={styles.buttonsContainer}>
            <Button
              type='cancel'
              onClick={() => push('/persons')}
            >
              Discard Changes
            </Button>
            <Button
              type='submit'
              className={styles.saveBttn}
              onClick={this.handleSubmit}
            >
              Save Changes
            </Button>
          </div>

        </form>

      </div>
    )
  }
}

export default inject(PERSON_STORE, GENERAL_STORE)(PersonInfoForm)
